import axios from "axios";

const API_URL =
  window.location.hostname === "localhost"
    ? process.env.REACT_APP_BACKEND_URL_LOCAL + "/api/fichiers"
    : process.env.REACT_APP_BACKEND_URL_PROD + "/api/fichiers";

// 📌 **Stocker les informations de connexion**
const saveCredentials = (host, username, password) => {
  localStorage.setItem("ftpHost", host);
  localStorage.setItem("ftpUser", username);
  localStorage.setItem("ftpPass", password);
};

// 📌 **Récupérer les credentials**
const getAuthHeaders = () => {
  const host = localStorage.getItem("ftpHost");
  const username = localStorage.getItem("ftpUser");
  const password = localStorage.getItem("ftpPass");

  if (!host || !username || !password) {
    throw new Error("⛔ Non connecté. Veuillez vous reconnecter.");
  }

  return { headers: { host, username, password } };
};

// 🔌 **Connexion au FTP**
export const connectFTP = async (credentials) => {
  try {
    const response = await axios.post(`${API_URL}/connect`, credentials);
    if (response.data.success) {
      saveCredentials(credentials.host, credentials.username, credentials.password);
    }
    return response;
  } catch (error) {
    console.error("❌ Erreur lors de la connexion FTP :", error);
    throw error;
  }
};

// 📂 **Récupération des fichiers**
export const getFiles = async (path = "/") => {
  try {
    const headers = getAuthHeaders();
    const response = await axios.get(`${API_URL}/files?path=${path}`, headers);
    return response.data.files;
  } catch (error) {
    console.error("❌ Erreur lors de la récupération des fichiers :", error);
    throw error;
  }
};

// ⬆️ **Upload d'un fichier**
export const uploadFile = async (file, path) => {
  try {
    const headers = getAuthHeaders();
    const formData = new FormData();
    formData.append("file", file);
    formData.append("path", path);

    return axios.post(`${API_URL}/upload`, formData, {
      ...headers,
      headers: { ...headers.headers, "Content-Type": "multipart/form-data" },
    });
  } catch (error) {
    console.error("❌ Erreur lors de l'upload du fichier :", error);
    throw error;
  }
};

// ❌ **Suppression d'un fichier**
export const deleteFile = async (filename) => {
  try {
    const headers = getAuthHeaders();
    return axios.delete(`${API_URL}/files/${filename}`, headers);
  } catch (error) {
    console.error("❌ Erreur lors de la suppression du fichier :", error);
    throw error;
  }
};

// 📁 **Création d'un dossier**
export const createFolder = async (folderName) => {
  try {
    const headers = getAuthHeaders();
    return axios.post(`${API_URL}/create-folder`, { folderName }, headers);
  } catch (error) {
    console.error("❌ Erreur lors de la création du dossier :", error);
    throw error;
  }
};

// 📥 **Téléchargement d'un fichier**
export const downloadFile = async (filePath) => {
  try {
    const { host, username, password } = {
      host: localStorage.getItem("ftpHost"),
      username: localStorage.getItem("ftpUser"),
      password: localStorage.getItem("ftpPass")
    };
    
    const response = await fetch(`${API_URL}/download?file=${encodeURIComponent(filePath)}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${btoa(`${username}:${password}`)}`, // 🛡 Authentification basique
      },
    });

    if (!response.ok) throw new Error("Erreur lors du téléchargement");

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filePath.split("/").pop(); // Nom du fichier
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } catch (error) {
    console.error("❌ Erreur lors du téléchargement du fichier :", error);
  }
};

// ✏️ **Renommage d'un fichier**
export const renameFile = async (oldPath, newPath) => {
  try {
    const { host, username, password } = {
      host: localStorage.getItem("ftpHost"),
      username: localStorage.getItem("ftpUser"),
      password: localStorage.getItem("ftpPass")
    };

    const response = await fetch(`${API_URL}/rename`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${btoa(`${username}:${password}`)}`,
      },
      body: JSON.stringify({ oldPath, newPath }),
    });

    if (!response.ok) throw new Error("Erreur lors du renommage du fichier");
    return await response.json();
  } catch (error) {
    console.error("❌ Erreur lors du renommage du fichier :", error);
  }
};  

// 🔌 **Déconnexion du FTP**
export const disconnectFTP = async () => {
  try {
    localStorage.removeItem("ftpHost");
    localStorage.removeItem("ftpUser");
    localStorage.removeItem("ftpPass");
    console.log("🔌 Déconnexion réussie !");
  } catch (error) {
    console.error("❌ Erreur lors de la déconnexion :", error);
    throw error;
  }
};